import React, { Component } from 'react'
import * as utils from "../../utils";

import CreateEditPoll from "./create-edit-poll";
import PollVote from "./poll-vote";
import PollResults from "./poll-results";
import { connect } from 'react-redux';

function Polls(props) {
  // Right now we either show the poll(s) if they exist, else allow the host to
  // create one
  const polls = props.state.polls;
  if (polls.length === 0) {
    if (utils.isHost()) {
      return <CreateEditPoll />;
    } else {
      return <NoPollNotification />;
    }
  } else {
    return <PollViews polls={polls} />;
  }
}

function PollViews(props) {
  // There can be multiple polls per event
  const polls = props.polls;
  const pollNodes = polls.map((poll, i) => {
    const { id, voted, editingPoll, isHostVoting } = poll;
    const isHost = utils.isHost();
    if (editingPoll && isHost) {
      return <CreateEditPoll poll={ poll } key={ id } />;
    }
    if (voted || (isHost && !isHostVoting)) {
      return <PollResults poll={poll} key={id} />;
    } else {
      return <PollVote poll={poll} key={id} />;
    }
  });
  return (
    <div>
      {pollNodes}
    </div>
  )
}

function NoPollNotification() {
  return (
    <div className="poll-notice">
      The host has removed the poll from this event
    </div>
  )
}

function mapStateToProps(state) {
  return {
    state: {
      polls: state.polls
    }
  }
};

const connectedPolls = connect(mapStateToProps)(Polls);

export default connectedPolls;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/polls/components/index.es6